import { Injectable } from "@angular/core";
import { IspmHttpClient } from "@ispm/core/services/ispm-http-client";

@Injectable()
export class AdditionalConfigurationService {

    private endpoint = 'entity-tree/additionalConfiguration';

    constructor(private _ispmHttpClient: IspmHttpClient){}

    /**
     * returns the record based on queryString for additionalConfiguration resource
     * @param queryString
     * @param targetResource
     */
    getAdditionalConfiguration(queryString: string){
      return this._ispmHttpClient.get(this.endpoint + '?' + queryString);
    }


    /**
     * returns the record based on id for additionalConfiguration resource
     * @param id
     * @param targetResource
     */
    fetchDecisionPlans(queryString: string){
      return this._ispmHttpClient.get(this.endpoint + '/' + queryString);
    }

    /**
     * updates the endpoint with given data
     * @param data data to be updated
     */
    updateAdditionalConfiguration(data: any){
      return this._ispmHttpClient.put(this.endpoint + '/' + data.id, data);
    }

    /**
     * creates new entry for specified endpoint
     * @param data payload data used to create new entry
     */
    createAdditionalConfiguration(data: any){
      return this._ispmHttpClient.post(this.endpoint, data);
    }

}
